export default __webpack_public_path__ + "static/media/bg1.7da12df4.png";